import React, { useEffect, useRef, useState } from 'react';
import { productActionClick } from '../../../Utils/productAction';
import { images } from '../../../Constants/ImageUrls';
import {
  CrossButtonFullScreen,
  FullScreenVideo,
  ProductDetails,
  ProductImage,
  ProductSnippet,
  ProductSnippetOuter,
} from '../styled';
import Cookies from 'js-cookie';

const FullScreenVideoComponent = (props) => {
  const {
    videoData,
    setShowFullScreenVideo,
    setIsFullScreenVideoEnabled,
    autoPlay,
    remainingHeight,
    isCartOpen,
    setCurrentVideoIndex,
    setCurrentIndex,
    openVideoFullScreen,
  } = props;
  const videoRef = useRef(null);

  const [isPaused, setIsPaused] = useState(false);
  const [showGoToCart, setShowGoToCart] = useState(false);
  const [cardEffect, setCardEffect] = useState(false);

  useEffect(() => {
    const cartItems = Cookies.get('cart_items')?.split(',');
    cartItems?.filter((product_id) => {
      if (videoData?.productData?.id == product_id) {
        setShowGoToCart(true);
      }
    });
  }, [Cookies.get('cart_items')]);

  const handlePausePlay = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        setIsPaused(false);
      } else {
        videoRef.current.pause();
        setIsPaused(true);
      }
    }
  };

  const addProductToCart = () => {
    setCardEffect(true);
    setTimeout(() => {
      productActionClick('cart', videoData.productData, 1);
      setShowGoToCart(true);
      setIsPaused(true);
      setCardEffect(false);
    }, 200);
  };

  const handleCloseFullScreen = () => {
    setShowFullScreenVideo(false);
    setIsFullScreenVideoEnabled?.(false);
    setIsPaused(false);
    setCurrentVideoIndex?.(0);
    setCurrentIndex?.(0);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (videoRef.current) {
            if (isCartOpen) {
              videoRef.current.pause();
              setIsPaused(true);
            } else {
              if (entry.isIntersecting) {
                videoRef.current.play();
                setIsPaused(false);
              } else {
                videoRef.current.pause();
                setIsPaused(true);
              }
            }
          }
        });
      },
      { threshold: 0.5 },
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, [isCartOpen]);

  return (
    <FullScreenVideo
      remainingHeight={remainingHeight}
      openVideoFullScreen={openVideoFullScreen}
    >
      <CrossButtonFullScreen onClick={handleCloseFullScreen}>
        <img src={images.CrossWhite} width={20} height={20} alt="" />
      </CrossButtonFullScreen>
      <video
        autoPlay={autoPlay}
        loop
        ref={videoRef}
        onClick={handlePausePlay}
        playsInline
      >
        <source src={videoData.url} />
      </video>

      {isPaused && (
        <button className="pauseButton" onClick={handlePausePlay}></button>
      )}
      {videoData.viewCount && videoData.views && (
        <div className="viewCount">
          <img
            src="https://images.myloapp.in/NestJsUploads/1720595560968-View-count.webp"
            alt=""
          />
          {videoData.viewCount || videoData.views}
        </div>
      )}
      {videoData?.productData && (
        <ProductSnippetOuter>
          <ProductSnippet>
            <ProductImage>
              <img
                src={videoData?.productData?.image}
                width={80}
                height={80}
                alt=""
              />
            </ProductImage>
            <ProductDetails>
              <div className="nickname">{videoData?.productData?.nickname}</div>
            </ProductDetails>
            <div className="addToCart">
              <button
                className={cardEffect ? 'addToCartBtn opacity' : 'addToCartBtn'}
                onClick={addProductToCart}
              >
                {showGoToCart ? 'GO TO CART' : 'ADD TO CART'}
              </button>
            </div>
          </ProductSnippet>
        </ProductSnippetOuter>
      )}
    </FullScreenVideo>
  );
};

export default FullScreenVideoComponent;
